import React from 'react';

import BaseSvg, { BaseSvgProps } from '../../BaseSvg';

const ResistanceSvg: React.FunctionComponent<BaseSvgProps> = ({ className = '', fillColor }) => {
    return (
        <BaseSvg className={className} viewBox="0 0 40.89941 48">
            <path
                fill={fillColor}
                d="M21.18969,15.5h-4.12v7.44h4.12a3.68142,3.68142,0,0,0,2.79-.97,3.75732,3.75732,0,0,0,.94-2.73,3.81933,3.81933,0,0,0-.95-2.74A3.638,3.638,0,0,0,21.18969,15.5Z"
            />
            <path
                fill={fillColor}
                d="M40.4497,8c-11,0-20-6-20-8,0,2-9,8-20,8-4,35,20,40,20,40S44.4497,43,40.4497,8Zm-8.11,29.51h-6.97l-4.77-9.56h-3.53v9.56h-6.51V10.49h10.63c3.2,0,5.71.71,7.51,2.13a7.21618,7.21618,0,0,1,2.71,6.03,8.78153,8.78153,0,0,1-1.14,4.67005,8.14932,8.14932,0,0,1-3.57,3l5.64,10.91Z"
            />
        </BaseSvg>
    );
};

export default ResistanceSvg;
